import { SalesforceItem, ConfigurationItemWithStatus } from '../../../parser/ParserTypes';
import { translateTypeToHumanName } from '../../helpers';

export const getCsvHeaders = (
  columns: { field: string; headerName: string; showSortIcon?: boolean }[],
) => {
  return columns.map((column) => ({ label: column.headerName, value: column.field }));
};

export const addStatusAndUpdateType = (items: SalesforceItem[]): ConfigurationItemWithStatus[] =>
  items.map((item) => ({
    ...item,
    status: item.isActive ? 'Active' : 'Inactive',
    parentType: translateTypeToHumanName(item.parentType),
  }));
